const DEEP_LINK_KEY = 'arthelper_deep_link';

export function hasChatDeepLinkParams(search: string): boolean {
  const params = new URLSearchParams(search);
  return params.has('spark_id') || params.has('message') || params.get('display_upload_modal') === 'true';
}

// Store the current URL as the intended destination after authentication
export const storeDeepLink = (): void => {
  const currentUrl = window.location.pathname + window.location.search + window.location.hash;
  localStorage.setItem(DEEP_LINK_KEY, currentUrl);
};

// Get the stored deep link URL
export const getDeepLink = (): string | null => {
  return localStorage.getItem(DEEP_LINK_KEY);
};

// Clear the stored deep link URL
export const clearDeepLink = (): void => {
  localStorage.removeItem(DEEP_LINK_KEY);
};
